import { OPPORTUNITIES_FETCH, OPPORTUNITY_OPTIONS_FETCH } from './types';

export default {
  [OPPORTUNITIES_FETCH](state, payload) {
    const oppsAsOb = payload.map((opportunity) => {
      return {
        [opportunity.sfid]: opportunity,
      };
    });
    state.definitions = Object.assign({}, state.definitions, ...oppsAsOb);
  },
  [OPPORTUNITY_OPTIONS_FETCH](state, payload) {
    const oppsAsOb = payload.map((option) => {
      return {
        [option.opportunity.id]: option,
      };
    });
    state.options = Object.assign({}, state.options, ...oppsAsOb);
  },
};
